import { Box, styled } from '@mui/material';

const LeftSide = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export default LeftSide;
